import { render, staticRenderFns } from "./aboutUsCn.vue?vue&type=template&id=4c1a90d8&scoped=true&"
import script from "./aboutUsCn.vue?vue&type=script&lang=js&"
export * from "./aboutUsCn.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsCn.vue?vue&type=style&index=0&id=4c1a90d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a90d8",
  null
  
)

export default component.exports